<template>
	<BtnModal btn-text="查看图片" size="large" :title="documentList?'查看图片':`工单编号（${getWorkOrder.code}） 查看图片`"
		:okBtn="false" :openBefore="openBefore" width="100%" modal-class="preview-doc-dialog height-limit-dialog">
		<OrderPreviewDocpt :btnDisplay="false" :documentList="documentList"></OrderPreviewDocpt>
	</BtnModal>
</template>
<script>
	import {
		mapGetters,
		mapActions
	} from 'vuex'
	import OrderPreviewDocpt from '@c/stationWork/lookDocument/OrderPreviewDocpt.vue'
	export default {
		components: {
			OrderPreviewDocpt
		},
		props: {
			orderNum: {
				type: Number
			},
			documentList: {
				type: Array
			}
		},
		data() {
			return {}
		},
		computed: {
			...mapGetters(['getWorkOrder'])

		},
		methods: {

			...mapActions(['workOrderExist']),
			async openBefore() {
				if (!this.documentList) {
					return await this.workOrderExist()
				} else {
					return true

				}
			}
		},
		created() {

		},
		mounted() {

		}
	}
</script>
<style lang="less">
	.preview-doc-dialog {
		.ant-modal-content {
			height: 90vh;

			.ant-modal-body {
				padding: 0 !important;
			}
		}
	}
</style>
